import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectIsBuyPackageModalLoading } from '../../../../../../selectors/buyPackageModal';
import { buyPackageThunk } from '../../../../../../thunks';
import { TDispatch } from '../../../../../../types';
import { Button } from '@cian/ui-kit';
import { BuyButton } from './BuyButton';

export const BuyButtonContainer = () => {
  const isLoading = useSelector(selectIsBuyPackageModalLoading);

  const dispatch = useDispatch<TDispatch>();

  const handleButtonClick = React.useCallback(() => {
    dispatch(buyPackageThunk());
  }, [dispatch]);

  const button = (
    <Button onClick={handleButtonClick} loading={isLoading} fullWidth size="L">
      Оплатить
    </Button>
  );

  return <BuyButton button={button} />;
};
